import type { AnyAction } from 'redux';

import type { PhysicalAddress } from 'src/graphql/generated';

const defaultState = {
  addressLine1: undefined,
  addressLine2: undefined,
  state: undefined,
  suburb: undefined,
  postCode: undefined,
  country: undefined,
};

const RESET = 'session/postalAddress/RESET';
const UPDATE = 'session/postalAddress/UPDATE';

export const actionResetPostalAddress = () => ({
  type: RESET,
});

export const actionUpdatePostalAddress = (value: PhysicalAddress) => ({
  type: UPDATE,
  value,
});

export default (state: PhysicalAddress = defaultState, action: AnyAction) => {
  switch (action.type) {
    case RESET: {
      return defaultState;
    }
    case UPDATE: {
      return action.value;
    }
    default: {
      return state;
    }
  }
};

export const forTest = {
  defaultState,
  RESET,
  UPDATE,
};
